/**
 * GameHud — bundle for study pages. Mounts ComboCounter + ScoreBurst.
 * Resets the session combo when the lesson route changes.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ComboCounter } from './ComboCounter';
import { PromotionBurst } from './PromotionBurst';
import { ScoreBurst } from './ScoreBurst';
import { useAppStore } from '@/lib/store';

export function GameHud(): JSX.Element {
  const location = useLocation();
  const reset = useAppStore((s) => s.resetSessionCombo);

  useEffect(() => {
    reset();
    return () => reset();
  }, [location.pathname, reset]);

  return (
    <>
      <ComboCounter />
      <ScoreBurst />
      <PromotionBurst />
    </>
  );
}
